"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var YourSavingsCardState_1 = require("./YourSavingsCardState");
var ui_components_1 = require("@idp/ui-components");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var ReportingService_1 = require("../../../../api/ReportingService");
var utils_1 = require("@idp/ui-components/utils");
var styles = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var localStyles = require("./YourSavingsCard.scss");
var StateProvider_1 = require("../../../../api/StateProvider");
var Api_1 = require("../../../../api/Api");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../../cms/Cart.cms");
var Utils = require("../../../../utils/UtilityFunctions");
var Common = require("../../../../utils/CommonUtilFuntions");
var CartUtils = require("../../../../utils/CartUtilFunctions");
var components_1 = require("@idp/duc/components");
var YourSavingsCard = /** @class */ (function (_super) {
    __extends(YourSavingsCard, _super);
    function YourSavingsCard(props) {
        var _this = _super.call(this, props) || this;
        _this.savingCss = localStyles.savings;
        _this.api = new Api_1.default();
        _this.state = new YourSavingsCardState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.onPromoModalClose = _this.onPromoModalClose.bind(_this);
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.seeOfferDetails = _this.seeOfferDetails.bind(_this);
        _this.onSeeOfferDetailsClose = _this.onSeeOfferDetailsClose.bind(_this);
        return _this;
    }
    YourSavingsCard.prototype.render = function () {
        var _this = this;
        this.yourSavingsCardTexts = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common.yourSavings;
        this.removePromoApiErrMsg = this.yourSavingsCardTexts.removeApiErrTxt;
        var totalMonthlySavings = this.props.data.totalMonthlySavings;
        var totalOneTimeSavings = this.props.data.totalOneTimeSavings;
        var promotionArr = this.removeDuplicatePromos(this.props.data.promotionArr);
        var rewardArr = this.props.data.rewardsArr;
        this.lobType = Utils.getCurrentLOB();
        this.lobsInCart = Utils.getCurrentLOBList();
        this.savingCss = CartUtils.isExpupgradeViewEnable() ? localStyles.expsavings : localStyles.savings;
        this.savingsCardContainerClass = Utils.IsAccessoryOnlyInCart() ?
            [localStyles.container, styles.accSavingsCard].join(' ') :
            localStyles.container;
        return (React.createElement("div", null, (promotionArr.length > 0) || (totalOneTimeSavings > 0)
            || (totalMonthlySavings > 0 || rewardArr.length > 0) ? (React.createElement("div", { className: this.savingsCardContainerClass },
            !this.props.options.isNewSavingsComponent &&
                totalMonthlySavings > 0 && !this.props.data.hideTotalMonthlySavings &&
                React.createElement("div", { className: this.savingCss },
                    React.createElement("span", null, this.yourSavingsCardTexts.totalMonthlyLabel),
                    React.createElement("div", { className: localStyles.savingsPrice },
                        "$",
                        totalMonthlySavings.toFixed(2))),
            !this.props.options.isNewSavingsComponent &&
                totalOneTimeSavings > 0 &&
                React.createElement("div", { className: this.savingCss },
                    React.createElement("div", { tabIndex: 0 }, this.yourSavingsCardTexts.totalOneTimeLabel),
                    React.createElement("div", { className: localStyles.savingsPrice, tabIndex: 0 },
                        "$",
                        totalOneTimeSavings.toFixed(2))),
            rewardArr.map(function (reward, index) {
                return (React.createElement("div", { key: 'reward_' + index },
                    React.createElement("div", { className: localStyles.savings },
                        React.createElement("div", null,
                            React.createElement("div", { className: localStyles.lineItemName },
                                React.createElement(ui_components_1.Label, { testId: utils_1.default('Label', 'reward' + index), data: { isDecodingRequired: false,
                                        text: Common.replaceHTMLEntities(reward.displayName) }, options: {
                                        className: localStyles.labelstyle,
                                        tabIndex: 0,
                                    } })),
                            React.createElement("div", { className: [localStyles.seeoffer, localStyles.floatl].join(' ') }, (reward.legalDescription || reward.redeemRewardDetails) &&
                                React.createElement(components_1.Link, { kind: "textPlain", onClick: _this.seeOfferDetails.bind(_this, reward, _this.yourSavingsCardTexts.seeOfferDetailsLinkLabel), testId: components_1.Link.name + '_' +
                                        _this.yourSavingsCardTexts.seeOfferDetailsLinkLabel }, _this.yourSavingsCardTexts.seeOfferDetailsLinkLabel)),
                            React.createElement("div", { style: { clear: 'left' } })),
                        React.createElement("div", { className: localStyles.savingsPrice, tabIndex: 0 },
                            "$",
                            Number(reward.amount).toFixed(2)))));
            }),
            promotionArr.length > 0 &&
                React.createElement("div", { className: [this.savingCss, localStyles.promoCopy].join(' ') }, this.yourSavingsCardTexts.promoInfoLabel),
            promotionArr.map(function (promotion, index) {
                return React.createElement("div", { key: index },
                    React.createElement("div", { className: styles.besideLeft, style: { marginTop: '3px' } },
                        promotion.disclosureMsg ? React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Link', 'promoLegalInfo_Link'), onClick: _this.promoModalEvent.bind(_this, promotion.disclosureMsg, promotion.couponCode) }, promotion.couponCode) : React.createElement("span", null,
                            "\u00A0",
                            promotion.couponCode),
                        React.createElement("span", null,
                            "\u00A0",
                            promotion.displayName)),
                    React.createElement("div", { className: localStyles.removeLink },
                        React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Link', 'promoRemove_Link'), onClick: _this.removePromoEvent.bind(_this, promotion, _this.yourSavingsCardTexts.removeLinkLabel) }, _this.yourSavingsCardTexts.removeLinkLabel)),
                    React.createElement("div", { style: { clear: 'both' } }));
            }),
            React.createElement(ui_components_1.Modal, { testId: utils_1.default('Modal', 'promoDetail_Modal'), options: { center: true, className: { modalContentClass: styles.rennyModalCloseBtn },
                    isRedesign: true,
                    show: this.state.showPromoModal,
                    showClose: true, size: ModalProps_1.ModalSizes.MEDIUM,
                }, events: { onClose: this.onPromoModalClose } },
                React.createElement("div", { className: styles.rennyModalContainer },
                    React.createElement("div", null,
                        React.createElement(ui_components_1.Label, { data: { text: this.yourSavingsCardTexts.promoModalTitleLabel }, options: { className: styles.rennyModalTitle } })),
                    React.createElement("p", { style: { fontFamily: 'att', margin: '0 0 10px' }, id: "dialogDesc" }, this.state.promocodeDetails))),
            this.state.showSeeOfferDetailsModal && this.showOfferDetailsModal())) : ''));
    };
    YourSavingsCard.prototype.removeDuplicatePromos = function (appliedPromos) {
        var updatedPromos = [];
        var appliedPromoCodes = [];
        if (appliedPromos && appliedPromos.length > 0) {
            appliedPromos.forEach(function (promo) {
                if (appliedPromoCodes.indexOf(promo.couponCode) === -1) {
                    appliedPromoCodes.push(promo.couponCode);
                    updatedPromos.push(promo);
                }
            });
        }
        return updatedPromos;
    };
    YourSavingsCard.prototype.promoModalEvent = function (promolegalInfo, couponCode) {
        this.setState({ showPromoModal: true, promocodeDetails: promolegalInfo });
        setTimeout(function () {
            var modalCloseIcon = document.
                querySelectorAll('[data-test-id="Modal_promoDetail_Modal_Button_Close"]')[0];
            if (modalCloseIcon.hasOwnProperty('focus')) {
                modalCloseIcon.focus();
            }
        });
        this.reportingService.fireLinkClickEvent(couponCode, ReportingService_1.PageUrls.CART_PAGE);
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.PROMO_MODAL_PAGE);
    };
    YourSavingsCard.prototype.removePromoEvent = function (promotion, btnText) {
        var _this = this;
        this.props.events.doLoading(true);
        // Analytics Code: link click for verify action on address form button click
        this.reportingService.fireLinkClickEvent(btnText, ReportingService_1.PageUrls.CART_PAGE);
        var couponDetailsObject = this.lobsInCart.map(function (lobItem) {
            var _a;
            return ({
                action: 'REMOVE',
                couponCode: promotion === null || promotion === void 0 ? void 0 : promotion.couponCode,
                couponSequence: (_a = promotion === null || promotion === void 0 ? void 0 : promotion.displayOrder) === null || _a === void 0 ? void 0 : _a.toString(),
                lobType: lobItem,
            });
        });
        var removePromoCodeReqObj = {
            couponDetails: couponDetailsObject,
        };
        this.reportingService.firePromoCodeSubmitEvent(promotion === null || promotion === void 0 ? void 0 : promotion.couponCode, false, '-2', ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, false, btnText, undefined);
        this.api.applyPromoCode(removePromoCodeReqObj).then(function (response) {
            if (response && response.content) {
                _this.stateManager.set('cartUpdate', { cartRefresh: true });
                _this.setState({ promocodeDetails: '' });
                _this.reportingService.firePromoCodeSubmitEvent(promotion.promotionId, false, '0', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, false, btnText, undefined);
            }
            else if (response && response.error) {
                _this.props.events.displayPanelError(true, {
                    errorId: response.error.errorId,
                    message: response.error.message,
                });
                _this.reportingService.firePromoCodeSubmitEvent(promotion.promotionId, true, response.error.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, false, btnText, response.error.message);
            }
            _this.props.events.doLoading(false);
            _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
        })
            .catch(function (err) {
            var msg = _this.removePromoApiErrMsg;
            _this.props.events.displayPanelError(true, { errorId: '', message: msg });
            _this.reportingService.firePromoCodeSubmitEvent(promotion.couponCode, true, err && err.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, false, btnText, msg);
        });
    };
    YourSavingsCard.prototype.onPromoModalClose = function () {
        this.setState({ showPromoModal: false });
        // Analytics Code: link click for close action on Terms modal
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
    };
    YourSavingsCard.prototype.onSeeOfferDetailsClose = function () {
        this.setState({ showSeeOfferDetailsModal: false });
        // Analytics Code: link click for close action on Terms modal
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
    };
    YourSavingsCard.prototype.seeOfferDetails = function (obj, linkName) {
        this.rewardBoj = obj;
        this.reportingService.fireLinkClickEvent(linkName, ReportingService_1.PageUrls.SEE_OFFER_MODAL_PAGE);
        this.setState({ showSeeOfferDetailsModal: true });
    };
    YourSavingsCard.prototype.showOfferDetailsModal = function () {
        return (React.createElement(ui_components_1.Modal, { testId: "Modal_SeeOffer_Details", options: { className: { modalContentClass: styles.rennyModalCloseBtn },
                show: true, showClose: true }, events: { onClose: this.onSeeOfferDetailsClose }, accessibilityText: "_SeeOffer_Details" },
            React.createElement("div", { className: styles.rennyModalContainer },
                React.createElement("div", null,
                    React.createElement(ui_components_1.Label, { data: { text: this.yourSavingsCardTexts.seeOfferModalTitleLabel }, options: { className: styles.rennyModalTitle } })),
                this.rewardBoj.legalDescription &&
                    React.createElement("div", { className: [styles.wordwrapb, styles.mb10].join(' ') },
                        React.createElement("p", { dangerouslySetInnerHTML: {
                                __html: Common.replaceHTMLEntities(this.rewardBoj.legalDescription),
                            } })),
                this.rewardBoj.redeemRewardDetails &&
                    React.createElement("div", { className: styles.wordwrapb },
                        React.createElement("p", { dangerouslySetInnerHTML: {
                                __html: Common.replaceHTMLEntities(this.rewardBoj.redeemRewardDetails),
                            } })))));
    };
    return YourSavingsCard;
}(React.Component));
exports.default = YourSavingsCard;
//# sourceMappingURL=YourSavingsCard.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/YourSavingsCard/YourSavingsCard.js
// module id = 2241
// module chunks = 8